export const getDataFromChapters = (chapters, data_key) => {
  const data = chapters.map((ch) => {
    return ch[data_key] && ch[data_key].length > 0 ? ch[data_key] : [];
  });
  const data_list = data.flat(1);
  return [...new Set(data_list)];
};
